module.exports = __webpack_public_path__ + "img/tiktok-icon.36f54032.svg";